/** Media kits destacados en home e índice. */
export const FEATURED_MEDIA_KIT_SLUGS = [
  'expedientesdeldelito',
  'noticias',
  'marketingenmovimiento',
  'ladosispositiva',
];

function normalizeSlug(slug) {
  return String(slug || '').toLowerCase().trim();
}

export function isFeaturedMediaKit(kit) {
  return FEATURED_MEDIA_KIT_SLUGS.includes(normalizeSlug(kit?.slug));
}

export function sortMediaKits(list) {
  const orderIndex = (slug) => {
    const i = FEATURED_MEDIA_KIT_SLUGS.indexOf(String(slug || '').toLowerCase());
    return i === -1 ? FEATURED_MEDIA_KIT_SLUGS.length : i;
  };
  return [...(list || [])].sort((a, b) => {
    const diff = orderIndex(a.slug) - orderIndex(b.slug);
    if (diff !== 0) return diff;
    return (a.name || '').localeCompare(b.name || '', 'es');
  });
}

export function partitionMediaKits(kits) {
  const featured = [];
  const rest = [];
  (kits || []).forEach((kit) => {
    if (isFeaturedMediaKit(kit)) featured.push(kit);
    else rest.push(kit);
  });
  featured.sort(
    (a, b) =>
      FEATURED_MEDIA_KIT_SLUGS.indexOf(normalizeSlug(a.slug)) -
      FEATURED_MEDIA_KIT_SLUGS.indexOf(normalizeSlug(b.slug)),
  );
  return { featured, rest };
}
